import _ from 'underscore';

import {Tag} from 'folder-items/FileConstants';
import deepCopy from 'lib/deepCopy';

function copyTag(tag: Tag): Tag {
  return deepCopy(tag);
}

export function mergeTemplateTags(tags: Array<Tag>, templateTags: Array<Tag>): Array<Tag> {
  return tags.map((tag) => {
    const templateTag = _.findWhere(templateTags, {name: tag.name});
    return templateTag ? copyTag(templateTag) : copyTag(tag);
  });
}
